<template>
  <section
    class="relative mt-80p bg-cover flex items-stretch h-full text-white"
    :style="$route.name === 'poorten' ? `background-image: url('${require('~/assets/img/bg.png')}');` : ''"
  >
    <div
      :class="{'bg-background xl:pb-27 z-30': $route.name !== 'poorten'}"
      class="md:w-3/5 pt-12 sm:pt-24 pb-24 sm:pb-36 px-6 sm:px-12 md:px-16 lg:px-32 xl:px-40 xxl:px-64"
    >
      <h1 :class="{'text-primary': $route.name !== 'poorten'}" v-text="page.title"/>
      <h3 class="text-secondary text-lg pb-4" v-text="page.subtitle"/>
      <div :class="{'text-primary': $route.name !== 'poorten'}" v-html="page.template.text"/>
      <div v-if="$route.name !== 'poorten'" class="pt-12">
        <h3 class="text-primary">
          Heeft u liever persoonlijk advies van ons?
        </h3>
        <a
          :href="`tel:${getSetting('phone')}`"
          aria-label="Neem contact op met ons"
          target="_blank"
          rel="noopener"
          class="text-secondary text-title"
        >
          <font-awesome-icon :icon="['fas', 'phone-alt']" aria-hidden="true"/>
          <span class="font-semibold" aria-hidden="true" v-text="getSetting('phone')"/>
        </a>
      </div>

      <div
        class="absolute md:right-42-5p lg:right-40-5p xl:right-40p bottom-0 sm:bottom-5 md:bottom-4 lg:bottom-5 z-10"
      >
        <div class="relative">
          <button
            v-if="gates.length"
            class="btn-square"
            @click="toggle"
          >
            <span>Bekijk direct</span>
            <font-awesome-icon :icon="['far', 'arrow-circle-down']" size="lg" aria-hidden="true"/>
          </button>
          <transition name="fade">
            <ul
              v-if="open"
              v-click-outside="onClickOutside"
              class="absolute right-0 w-64 top-full bg-primary transition duration-200 pt-3 z-10"
            >
              <li v-for="gate in gates" :key="gate.slug" class="pb-3">
                <nuxt-link
                  :to="localeRoute({name: 'configurator-slug', params: {slug: gate.slug}})"
                  class="flex no-underline w-full font-bold text-white hover:text-highlight"
                >
                  {{ gate.title }}
                </nuxt-link>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
    <div class="hidden w-2/5 lg:w-1/3 md:flex flex-col mr-12 lg:mr-24 z-10">
      <img
        :src="page.image && page.image.url"
        alt=""
        aria-hidden="true"
        class="object-cover flex-grow"
      >
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
    gates: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    ...mapState({
      settings: state => state.settings,
    }),
  },
  methods: {
    getSetting(key) {
      return this.settings.find(setting => setting.key === key)?.value;
    },
    toggle() {
      this.open = !this.open;
    },
    onClickOutside() {
      this.open = false;
    },
  },
};
</script>

<style scoped>
ul {
  li {
    position: relative;
    margin-left: 40px;
    &::before {
      content: '';
      position: absolute;
      left: -18px;
      top: 6px;
      height: 10px;
      width: 10px;
      border-radius: 999px;
      background-color: theme('colors.highlight');
    }
  }
}
</style>
